<template>
  <div class="dealers">
    <v-touch class="swipe-block" v-on:swiperight="onSwipeRoght"></v-touch>
    <!--    <vue-headful :title="getTitle" description="" />-->
    <div class="container car-view car-page">
      <div class="main-header">
        <CarBreadCrumbs :car="car" :loaded="dataLoadedCar"/>

        <div class="main-header-right">
          <!--          <a v-if="car.can_edit" :href="'https://admin.bilaskra.is/pages/login?car_id='+car.id+'&token='+$store.state.access_token" target="_blank" style="font-size: 14px;">Edit</a>-->
          <!--          <a v-if="car.can_edit" :href="'http://192.168.1.15:8081/pages/login?car_id='+car.id+'&token='+$store.state.access_token" target="_blank" style="font-size: 14px;">Edit</a>-->
          <a
              v-if="car.can_edit"
              :href="
              'https://admin.bilaskra.is/pages/login?car_id=' +
              car.id +
              '&token=' +
              $store.state.access_token
            "
              target="_blank"
              style="font-size: 14px"
          >
            Edit
          </a>
          <span class="main-header-right-data">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 16"
                width="24px"
                height="16px"
            >
              <path
                  fill="#000"
                  fill-rule="nonzero"
                  d="M12.012 0C4.075 0 0 8 0 8s3.075 8 12.012 8c8.093 0 12.011-7.969 12.011-7.969S20.074 0 12.012 0zm.018 13c-2.902 0-5-2.188-5-5 0-2.813 2.098-5 5-5s5 2.187 5 5c0 2.812-2.098 5-5 5zm0-8c-1.658.003-3 1.393-3 3 0 1.606 1.342 3 3 3s3-1.395 3-3c0-1.608-1.342-3.003-3-3z"
                  opacity=".2"
              />
            </svg>
            <span class="car-seen" :class="[ { 'b-empty shine-short': !dataLoadedCar } ]">
                {{ car.views }}
            </span>
          </span>
          <span class="main-header-right-data">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 29 29"
                width="29px"
                height="29px"
            >
              <g fill="none" fill-rule="evenodd">
                <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
                <path
                    fill="#FFF"
                    fill-rule="nonzero"
                    d="M20.2375 12.5751328c0-3.96376135-2.1875-5.31209-4.2333333-5.61262108 0-.02030616.0041666-.04061231.0041666-.0649797C16.0083333 6.39800062 15.5541667 6 15 6c-.5541667 0-.9916667.39800062-.9916667.89753202 0 .02436739 0 .04467354.0041667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074348C9.7625 17.204936 8.58333333 17.7004061 7 19h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.4248672zM15 21c2.073501 0 3.7756286-.4627907 4-1h-8c.2166344.5372093 1.926499 1 4 1z"
                />
              </g>
            </svg>
            <span>
              <b>
                Síðast uppfært
                <span class="data-update-car"
                      :class="[ { 'b-empty shine-short': !dataLoadedCar } ]">
                    {{
                    moment().diff(moment($store.state.dealers.newCar && $store.state.dealers.newCar.updated, "YYYY-MM-DD"), "days")
                  }}
                </span>
                dögum
              </b>
            </span>
          </span>
          <div class="mobile-main-meta">
            <span class="mobile-main-meta-item">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  width="16px"
                  height="16px"
              >
                <path
                    fill="#000"
                    fill-rule="nonzero"
                    d="M12.8596879 7.9649362c0-.3370213-.2697305-.6100426-.6022127-.6100426H8.57225532V3.6750071c0-.338156-.27438298-.6124255-.61231206-.6124255-.33815603 0-.612539.2742695-.612539.6124255v4.2875461c0 .3382695.27438297.612539.612539.612539h4.29787234c.3321418 0 .6018723-.2731348.6018723-.610156m1.8390922-.0038582c0 3.7217589-3.0166241 6.7388369-6.73758861 6.7388369-3.72119149 0-6.73758865-3.017078-6.73758865-6.7388369 0-3.7217589 3.01639716-6.73883687 6.73758865-6.73883687 3.72096451 0 6.73758861 3.01707797 6.73758861 6.73883687m1.2233759 0C15.922156 3.5642553 12.3579007 0 7.96119149 0 3.56425532 0 0 3.5642553 0 7.961078c0 4.3968227 3.56425532 7.961078 7.96119149 7.961078 4.39670921 0 7.96096451-3.5642553 7.96096451-7.961078"
                    opacity=".2"
                />
              </svg>
              <span>
                Á söluskrá í
                <b>2 daga</b>
              </span>
            </span>
            <span class="mobile-main-meta-item">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 16"
                  width="24px"
                  height="16px"
              >
                <path
                    fill="#000"
                    fill-rule="nonzero"
                    d="M12.012 0C4.075 0 0 8 0 8s3.075 8 12.012 8c8.093 0 12.011-7.969 12.011-7.969S20.074 0 12.012 0zm.018 13c-2.902 0-5-2.188-5-5 0-2.813 2.098-5 5-5s5 2.187 5 5c0 2.812-2.098 5-5 5zm0-8c-1.658.003-3 1.393-3 3 0 1.606 1.342 3 3 3s3-1.395 3-3c0-1.608-1.342-3.003-3-3z"
                    opacity=".2"
                />
              </svg>
              <span>{{ car.views }}</span>
            </span>
          </div>
          <SaveSearch
              :car_id="id"
              :subscriber="car.subscriber"
              :is_new_car="true"
          />
        </div>
      </div>
      <div class="mobile-main-header"
           :style="$store.state.isApp ? (isIos ? 'margin-top:30px;':'margin-top:70px;') : 'margin-top: 120px'">
        <div class="mobile-main-header-noti">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 29 29"
              width="29px"
              height="29px"
          >
            <g fill="none" fill-rule="evenodd">
              <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
              <path
                  fill="#FFF"
                  fill-rule="nonzero"
                  d="M20.2375 12.5751328c0-3.96376135-2.1875-5.31209-4.2333333-5.61262108 0-.02030616.0041666-.04061231.0041666-.0649797C16.0083333 6.39800062 15.5541667 6 15 6c-.5541667 0-.9916667.39800062-.9916667.89753202 0 .02436739 0 .04467354.0041667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074348C9.7625 17.204936 8.58333333 17.7004061 7 19h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.4248672zM15 21c2.073501 0 3.7756286-.4627907 4-1h-8c.2166344.5372093 1.926499 1 4 1z"
              />
            </g>
          </svg>
          <span>Vakta verð á ökutæki</span>
        </div>
        <SaveSearch :car_id="id" :is_new_car="true" :sub="0"/>
      </div>
      <div class="main-content">
        <transition name="toggle" mode="out-in" :duration="500">
          <div
              class="car-image-wrapper-empty b-empty shine-long"
              v-if="!this.$store.state.dealers.dataCarLoadedFlag"
          ></div>

          <LightGal
              v-else
              :photos="photos"
              :car="car"
              @lookTestDrive="scrollToTestDrive"
          />

        </transition>

        <div class="main-base-right-side">
          <div class="main-basic-info">
            <div class="main-basic-info__col">
              <div class="main-basic-info-header">
                <div class="main-basic-info-header__title">
                  <h1
                      class="main-basic-info-header__title-brand"
                      :class="{ 'b-empty shine-short': !dataLoadedCar }"
                  >
                    {{ car.brand }}
                  </h1>
                  <h2
                      class="main-basic-info-header__title-model"
                      :class="{ 'b-empty shine-short': !dataLoadedCar }"
                  >
                    {{ getCarModel }}
                  </h2>
                  <div class="main-basic-info-header__car_status" v-if="car.tags" v-text="car.tags"></div>
                </div>
                <div
                    class="main-basic-info-header__image"
                    :class="{ 'b-empty shine-short': !dataLoadedCar }"
                >
                  <img @error="logoLoadError" :src="urlBrandLogo" alt v-show="dataLoadedCar"/>
                </div>
              </div>

              <div
                  v-if="flagCarInStock"
                  class="main-basic-info-header__after-block"
              >
                <div>
                  <div
                      class="package-count"
                      v-show="car.tags"
                      :class="[{ 'in-stock': inStock }, { expected: !inStock }]"
                  >
                    <span>{{ car.tags }}</span>
                  </div>
                </div>

                <car-number-or-id
                    class="main-header-serial-number"
                ></car-number-or-id>

                <!--                                <div class="main-header-serial-number">-->
                <!--                                    {{flagCarInStock ? (car.registration_number ?'Fastanúmer:':'') : 'Raðnúmer:'}}-->
                <!--                                    <b class="main-header-serial-number&#45;&#45;b"-->
                <!--                                       :class="{ 'b-empty shine-short': !dataLoadedCar }">-->
                <!--                                        {{ flagCarInStock ? (car.registration_number?car.registration_number:'') :-->
                <!--                                        car.id }}-->
                <!--                                    </b>-->
                <!--                                </div>-->
              </div>
              <hr class="hr"/>
              <transition name="toggle" mode="out-in" :duration="500">
                <car-main-basic-info-data :car="car"/>
              </transition>
              <hr class="hr"/>

              <transition name="toggle" mode="out-in" :duration="500">
                <car-basic-info-data v-if="!flagCarInStock" :car="car"/>
              </transition>

              <hr class="hr" v-if="!flagCarInStock"/>

              <div v-if="+car.price_hide === 1" class="main-basic-info-data" :class="{'mb-4': !$device.tablet()}">
                <div v-if="+car.price_hide === 1 && +car.check_price === 1" class="main-basic-info-data__item text-bold">Leitið til sölumanna</div>
                <div v-else-if="+car.price_hide === 1 && +car.check_price === 0" class="main-basic-info-data__item text-bold">Sérpöntun</div>
              </div>

              <PriceBlock
                  :propPriceHide="car.price_hide == 0"
                  :propCheckPricee="car.check_price == 1"
                  :propPrice="parseInt(car.price)"
                  :propDiscountPrice="car.discount && parseInt(car.discount)"
                  :propLoaded="dataLoadedCar"
                  :car="car"
              />

              <company-and-form-btn-block
                  v-if="$device.tablet()"
                  style="margin-top: 30px;"
                  :loaded="$store.getters.carLoaded"
                  :car="car"
              />

              <div v-if="flagCarInStock && car.description" class="main-basic-info__section">
                <div class="main-basic-info__parking">
                  <span>{{ car.description }}</span>
                </div>
              </div>
            </div>

            <div class="main-basic-info__col">
              <company-and-form-btn-block
                  v-if="!$device.tablet()"
                  :loaded="$store.getters.carLoaded"
                  :car="car"
              />

              <ad-car  class="ad-car-block" v-if="$device.tablet() && ad" :ad="ad"/>


<!--              <hr class="hr"/>
              <amount-cars-available
                  :propLogo="getCompanyImg(car.company && car.company.logo)"
                  :propBrand="car.brand"
                  :propNameCompany="car.company && car.company.name"
                  :propCompanyAddress="car.company && car.company.location"
                  :propAmountCars="car.company ? car.company.total_cars : []"
                  :loaded="$store.getters.carLoaded"
                  :company="car.company"
              />

              <hr class="hr"/>
              <template v-if="!$store.state.isApp">
                <CarFormNavBtn :loaded="$store.getters.carLoaded"/>
              </template>-->
            </div>

            <div class="mobile-main-basic-info-meta">
              <span class="main-header-right-data">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    width="16px"
                    height="16px"
                >
                  <path
                      fill="#000"
                      fill-rule="nonzero"
                      d="M12.8596879 7.9649362c0-.3370213-.2697305-.6100426-.6022127-.6100426H8.57225532V3.6750071c0-.338156-.27438298-.6124255-.61231206-.6124255-.33815603 0-.612539.2742695-.612539.6124255v4.2875461c0 .3382695.27438297.612539.612539.612539h4.29787234c.3321418 0 .6018723-.2731348.6018723-.610156m1.8390922-.0038582c0 3.7217589-3.0166241 6.7388369-6.73758861 6.7388369-3.72119149 0-6.73758865-3.017078-6.73758865-6.7388369 0-3.7217589 3.01639716-6.73883687 6.73758865-6.73883687 3.72096451 0 6.73758861 3.01707797 6.73758861 6.73883687m1.2233759 0C15.922156 3.5642553 12.3579007 0 7.96119149 0 3.56425532 0 0 3.5642553 0 7.961078c0 4.3968227 3.56425532 7.961078 7.96119149 7.961078 4.39670921 0 7.96096451-3.5642553 7.96096451-7.961078"
                      opacity=".2"
                  />
                </svg>
              </span>
              <span class="main-header-right-data">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 16"
                    width="24px"
                    height="16px"
                >
                  <path
                      fill="#000"
                      fill-rule="nonzero"
                      d="M12.012 0C4.075 0 0 8 0 8s3.075 8 12.012 8c8.093 0 12.011-7.969 12.011-7.969S20.074 0 12.012 0zm.018 13c-2.902 0-5-2.188-5-5 0-2.813 2.098-5 5-5s5 2.187 5 5c0 2.812-2.098 5-5 5zm0-8c-1.658.003-3 1.393-3 3 0 1.606 1.342 3 3 3s3-1.395 3-3c0-1.608-1.342-3.003-3-3z"
                      opacity=".2"
                  />
                </svg>
                <span>{{ car.views }}</span>
              </span>
            </div>
            <div class="mobile-main-basic-info-line"></div>
            <!-- <div class="main-basic-info-location">
                                                                <span v-if="car.company">{{ car.company.name }} - {{ car.company.address }}</span>
            </div>-->
          </div>
        </div>
      </div>

      <div class="main-description-wrap">
        <div class="main-description-promo" v-if="$store.getters.carLoaded && !$store.state.isPrerender">
          <car-page-ad v-if="ad && isPackageDescription" :ad="ad"/>
        </div>

        <div class="main-description">
          <dealer-packs
              v-if="$store.state.dealers.dataCarLoadedFlag"
              :carPacks="car.package_description"
              :carCompany="car.company"
              :car="car"
          />
        </div>
      </div>

      <SliderInStock v-if="showCarsInStock" :cars="carsInStock"/>

      <div class="main-description-wrap">
        <div class="main-description-promo ad" v-if="$store.getters.carLoaded">
          <car-page-ad v-if="ad && !isPackageDescription" :ad="ad"/>
        </div>
        <div class="main-description" style="width: 100%">
          <transition name="fade" :duration="800">
            <div
                class="block-hidden-before-loaded-data"
                v-if="$store.getters.carLoaded"
            >
              <!-- Table model cars -->
              <TableOtherModels
                  v-if="showTableOtherModels"
                  :car="car"
                  :id="id"
              />
            </div>
          </transition>
        </div>
      </div>
    </div>
    <calculator
        v-if="car.price > 0"
        :priceValue="priceWithDiscount"
        :electroCar="isElectroCar"
        :hybridCar="isHybridCar"
        :carId="car.id"
        :car-year="car.model_year"
        :co2="car.co2"
        :thumbnail="car.thumbnail"
    />
    <!--
       <Calculator
            v-if="car.price > 0"
            :title="'Reiknivél'"
            :electro-car="isElectroCar"
            :hybrid-car="isHybridCar"
            :price-value="priceWithDiscount"
            :co2="car.co2"
            :dev-mode="true"
        ></Calculator>
    -->

    <VSectionTestDrive
        ref="testDriveSection"
        v-for="(article, i) in car.blog"
        :key="i"
        :post="article"
        :title="article.title"
        :description="article.description"
        :imageUrl="article.img && article.img.img"
        :video-url="article.video"
        :isPlayTestDrive="isPlayTestDrive"
        @testDrivePlayed="isPlayTestDrive = false"
    />

    <transition name="fade" :duration="800">
      <BlogArticle
          v-if="car.id && car.company && car.company.active == 1"
          :propCarID="car.id.toString()"
      />
    </transition>

    <transition name="fade" :duration="800">
      <SalonsOfCars
          v-if="car.company && car.company.active == 1"
          :company="car.company"
      />
    </transition>

    <div
        class="container car-view contact-form-anchor"
        id="scroll-contact-form"
    >
      <div class="main-description-wrap">
        <div class="main-description-promo">
        </div>
        <transition name="fade" :duration="800">
          <div
              class="block-hidden-before-loaded-data section-content"
              v-if="$store.getters.carLoaded"
          >
            <ContactForm
                :car="car"
                :brandUrl="brand_url"
                :entry-car-id="parseInt(car.id)"
                ref="contactFormCar"
            />
          </div>
        </transition>
      </div>
    </div>

    <div class="container car-view">
      <div
          class="main-header main-description-details-breadcrumbs similar-cars-slider"
      >
        <CarBreadCrumbs :car="car" :loaded="dataLoadedCar"/>
      </div>
      <div v-if="dataLoadedCar" class="main-description-details">
        <DealerCarsSlider :scar="getCarsForSlider"/>
      </div>
    </div>

    <div v-if="showVideoPupup" class="test-drive-video">
      <div class="bg" @click="closeVideoPupup"></div>
      <div class="blog-video">
        <!--        <embed :src="testDriveVideoUrl">-->
        <iframe :src="testDriveVideoUrl"
                allowfullscreen="allowfullscreen"
                mozallowfullscreen="mozallowfullscreen"
                msallowfullscreen="msallowfullscreen"
                oallowfullscreen="oallowfullscreen"
                webkitallowfullscreen="webkitallowfullscreen"></iframe>
      </div>
    </div>
    <Footer class="footer-main" v-if="isIosApp"/>
  </div>
</template>

<script>
import DealerPacks from "../components/Dealers/DealerPacks.vue";
import DealerCarsSlider from "../components/Dealers/DealerCarsSlider.vue";
import ContactForm from "../components/Dealers/ContactForm.vue";
import globalNewCar from "../helpers/globalNewCar";
import SaveSearch from "../components/SaveSearch.vue";
import LightGal from "../components/LightGal.vue";
import TableOtherModels from "@/components/Dealers/TableOtherModels";
import BlogArticle from "@/components/Dealers/BlogArticle";
import AmountCarsAvailable from "@/components/Dealers/AmountCarsAvailable";
import PriceBlock from "@/components/Dealers/PriceBlock";
import SalonsOfCars from "@/components/Dealers/SalonsOfCars";
import CarBasicInfoData from "@/components/Dealers/CarBasicInfoData";
import CarMainBasicInfoData from "@/components/Dealers/CarMainBasicInfoData";
import CarFormNavBtn from "@/components/Dealers/CarFormNavBtn";
import Calculator from "@/components/Dealers/Calculator.vue";
import scroll from "../helpers/scroll";
import SliderInStock from "@/components/Dealers/SliderInStock";
import CarBreadCrumbs from "@/components/Dealers/CarBreadCrumbs";
import CarNumberOrId from "@/components/Dealers/CarNumberOrId";
import urls from "@/mixins/newCars/urls";

import VSectionTestDrive from "@/components/Dealers/TestDrive";
import convertCategory from "@/helpers/convertCategory";
import {blog} from "@/staticData/routesName/blog"
import getBaseUrl from "@/helpers/getBaseUrl";
import Footer from "@/components/Footer";
import {mapActions, mapGetters, mapState} from "vuex";
import CarPageAd from "@/components/global/CarPageAd";
import CompanyAndFormBtnBlock from "@/components/global/CompanyAndFormBtnBlock";
import adCar from "@/components/global/AdCar";

export default {
  mixins: [urls],
  components: {
    CarPageAd,
    DealerPacks,
    DealerCarsSlider,
    SaveSearch,
    LightGal,
    TableOtherModels,
    BlogArticle,
    ContactForm,
    PriceBlock,
    AmountCarsAvailable,
    SalonsOfCars,
    CarBasicInfoData,
    CarMainBasicInfoData,
    CarFormNavBtn,
    Calculator,
    CarBreadCrumbs,
    SliderInStock,
    CarNumberOrId,
    VSectionTestDrive,
    Footer,
    CompanyAndFormBtnBlock,
    adCar
  },
  data: () => ({
    s: "",
    filtes: {},
    id: 0,
    curPack: null,
    logoError: false,
    dialog: null,
    isSuccessContactForm: false,
    isPlayTestDrive: false,
    showVideoPupup: false,
    ad: null
  }),
  metaInfo() {
    return {
      title: this.getTitle,
      titleTemplate: '%s | bilaskra.is',
      meta: this.getMeta,
      link: [
        {
          rel: 'canonical',
          href: getBaseUrl() + this.$route.fullPath
        }
      ],
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    }
  },
  methods: {
    ...mapActions({
      'getAd': "ad/GET"
    }),
    scrollToTestDrive() {
      if (this.testDriveVideoUrl) {
        this.showVideoPupup = true;
      } else {
        this.$router.push(this.postBlogUrl);
      }
      /*
     let element = this.$refs.testDriveSection;
     var top = element[0].$el.offsetTop - 50;
     window.scrollTo(0, top);
     this.isPlayTestDrive = true;*/
    },
    /*getCompanyImg(i) {
      return globalNewCar.getCompanyImg(i);
    },*/
    onSwipeRoght() {
      let props = this.$router.resolve({name: "DealersCars"});
      let url = props.href + window.location.search;

      if (this.$route.fullPath != url) {
        this.$router.push(url);
      }
    },

    capitalizeFirstLetter(s) {
      return s ? s[0].toUpperCase() + s.slice(1) : s;
    },
    loadAd(){
      this.getAd({location: this.pageLocationId}).then(res => {
        if (res.data.status) {
          this.ad = res.data.ad;
        }
      });
    },
    init() {
      this.$store.dispatch("dealers/FETCH_CAR", this.id).then(res => {

        localStorage.setItem("view_key", this.car.views.view_key);
        this.car.views = this.car.views.count;
      });
      this.loadAd();
    },
    scrollUp() {
      scroll.to(0);
    },
    logoLoadError() {
      this.logoError = true;
    },
    closeVideoPupup() {
      this.showVideoPupup = false
    }
  },

  // Life cycle -- start
  mounted() {
    this.id = this.$route.params.id;
    if (this.id == (this.car && this.car.id)) {
      this.$store.state.dealers.dataCarLoadedFlag = true;
      this.scrollUp();
      if(!this.ad){
        this.loadAd();
      }
    } else {
      this.$store.state.car_id = this.id;
      this.scrollUp();
      this.init();
    }
    this.$store.state.selected_filters_count = null;
  },
  destroyed() {
    if (this.dialog) {
      this.dialog.close();
    }
    this.$store.state.car_id = 0;
    this.$store.state.dealers.dataCarLoadedFlag = false;
    // this.$store.state.car_data = null;
  },
  // Life cycle -- finish

  watch: {
    $route(to) {
      this.id = to.params.id;
      this.$store.state.dealers.dataCarLoadedFlag = false;
      this.init();
      this.scrollUp();
    },
  },
  computed: {
    ...mapGetters(["isIosApp"]),
    ...mapState({
      pageLocationId: (state) => state.ad.pageLocationId,
    }),
    showFormNavBtn() {
      return ["CarInStock", "Car", "DealerCar"].includes(this.$route.name);
    },
    car() {
      return this.$store.state.dealers.newCar;
    },
    isCarBlog() {
      return this.car.blog ? true : false;
    },
    isIos() {
      return this.$device.ios()
    },
    photos() {
      // let imageUrl = this.$store.state.imageUrl;
      for (let k in this.car.photos) {
        this.car.photos[k].big_photo = globalNewCar.getPicUrl(
            this.car.photos[k].file_name
        );
      }
      return this.car.photos;
    },
    showCarsInStock() {
      return false;
      //return  Number(this.car.status) === 1 && this.car.with_license_plate && this.car.with_license_plate.length;
    },
    flagCarInStock() {
      return this.$store.getters.flagCarInStock;
    },
    carsInStock() {
      return (
          this.car.with_license_plate &&
          this.car.with_license_plate.map((el) => {
            return {
              ...el,
              thumbnail: globalNewCar.getPicUrl(el.thumbnail),
              packageName: el.package_name,
              status: "2",
            };
          })
      );
    },
    inStock() {
      if (this.flagCarInStock) {
        return this.car.tag != "Frátekinn";
      } else {
        return "";
      }
    },
    dataLoadedCar() {
      return this.$store.getters.carLoaded;
    },
    urlBrandLogo() {
      if (this.car.brandObj) {
        return getBaseUrl() + this.car.brandObj.logo;
      }
      return "";
    },

    isElectroCar() {
      return this.car && this.car.fuel === "Rafmagn" && !this.car.fuel2;
    },
    isHybridCar() {
      return (
          this.car.fuel &&
          this.car.fuel === "Rafmagn" &&
          this.car.fuel2 &&
          !!this.car.fuel2.length
      );
    },
    getTitle() {
      if (!this.car.brand) {
        return "bilaskra.is";
      }
      let res = this.car.brand + " ";
      if (this.car.model_class) {
        res += " " + this.car.model_class;
      }

      if (this.car.model_name) {
        res += " " + this.car.model_name;
      }

      return res;
    },
    getTotal() {
      return this.car && this.car.status == 2
          ? this.car.company.total_cars.stock_cars
          : this.car.company.total_cars.new_cars;
    },
    priceWithDiscount() {
      return Number(this.car.discount > 0 ? this.car.discount : this.car.price);
    },
    showTableOtherModels() {
      return this.car.brands.length && this.car.status == 1;
    },
    testDrive() {
      return this.car.blog.length > 0 && this.car.blog[0];
    },
    testDriveVideoUrl() {
      return this.testDrive.video ? this.testDrive.video : '';
    },
    postBlogUrl() {
      const category = convertCategory(this.testDrive.category_id);
      return `${blog}/${category.url}/${this.testDrive.id}`;
    },
    getCarModel() {
      const car = this.car;
      return `${car.model_class ? car.model_class : ''} ${car.model_name ? car.model_name : ''} ${(car.package_name == "Staðalbúnaður" ? "" : car.package_name)}`;
    },
    getOgTitle() {
      const car = this.car;
      let title = `${car.brand}  ${car.model_class}`;
      let price = car.discount > 0 ? car.discount : car.price;

      if (car.model_name) {
        title += ' ' + car.model_name;
      }

      if (car.transmision) {
        title += " | " + car.transmision;
      }

      if (car.drive_train) {
        title += " | " + car.drive_train;
      }

      if(this.car.price_hide == 1 && this.car.check_price == 1){
        title += ' | Leitið til sölumanna';
      }else if(this.car.price_hide == 1 && this.car.check_price == 0){
        title += ' | Sérpöntun';
      }else{
        title += " " + (parseInt(price).format()) + " kr."
      }

      console.log("PRICE",title);
      console.log(">>>1",this.car.check_price);
      console.log(">>>1",this.car.price_hide);

      return title;
    },
    getMateData() {
      if (this.car && this.car.meta) {
        return this.car.meta;
      } else {
        return {
          image: '/img/share2.png?33',
          width: 0,
          height: 0
        }
      }
    },
    getMeta() {
      const meta = this.getMateData;
      let image = '??';
      if (this.car) {
        image = meta && meta.image ? meta.image : '/img/share2.png?22';
      }
      let res = [
        {name: 'og:title', content: this.getOgTitle},
        {
          name: 'og:description',
          content: 'Bílaskrá.is - Nýir bílar allra umboða á einum stað'
        },
        {name: 'og:image', content: image},
        {name: 'og:height', content: meta.height},
        {name: 'og:width', content: meta.width},
      ];

      if (this.car.disabled == 1) {
        res.push({name: 'robots', content: 'noindex'});
      }
      return res;
    },
    isPackageDescription() {
      return this.car.package_description && this.car.package_description.some(e => e.data.length > 0)
    },
    getCarsForSlider() {
      const addProp = {isSlider: true, ad: true, ...this.ad};

      if(this.car.sl && this.car.sl.filter(e => e.ad === true).length === 0){
        this.car.sl.unshift(addProp)
      }

      return this.car.sl;
    }
  }
};
</script>
